import ForgotPasswordContent from "src/components/Auth/ForgotPasswordContent";

const ForgotPassword = () => {
  return <ForgotPasswordContent />;
};

export default ForgotPassword;
